import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const TeamPage = lazy(() => import('../pages/team/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const BookingPage = lazy(() => import('../pages/booking/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogDetailPage = lazy(() => import('../pages/blog/detail/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const TeamMemberPage = lazy(() => import('../pages/team/member/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Admin Pages
const AdminLogin = lazy(() => import('../pages/admin/login/page'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));
const AdminAnalytics = lazy(() => import('../pages/admin/analytics/page'));
const AdminContent = lazy(() => import('../pages/admin/content/page'));
const AdminServices = lazy(() => import('../pages/admin/services/page'));
const AdminTestimonials = lazy(() => import('../pages/admin/testimonials/page'));
const AdminPosts = lazy(() => import('../pages/admin/posts/page'));
const AdminPostNew = lazy(() => import('../pages/admin/posts/new/page'));
const AdminPostEdit = lazy(() => import('../pages/admin/posts/edit/page'));
const AdminFAQs = lazy(() => import('../pages/admin/faqs/page'));
const AdminBookings = lazy(() => import('../pages/admin/bookings/page'));
const AdminMessages = lazy(() => import('../pages/admin/messages/page'));
const AdminTeam = lazy(() => import('../pages/admin/team/page'));
const AdminContactSettings = lazy(() => import('../pages/admin/contact-settings/page'));
const AdminAboutSettings = lazy(() => import('../pages/admin/about-settings/page'));
const AdminSiteDesign = lazy(() => import('../pages/admin/site-design/page'));
const AdminUsers = lazy(() => import('../pages/admin/users/page'));
const AdminNavbarFooterSettings = lazy(() => import('../pages/admin/navbar-footer-settings/page'));
const AdminGallery = lazy(() => import('../pages/admin/gallery/page'));

// Public Layout Wrapper
const PublicLayout = ({ children }: { children: React.ReactNode }) => (
  <>
    <Navbar />
    {children}
    <Footer />
  </>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <PublicLayout><HomePage /></PublicLayout>,
  },
  {
    path: '/about',
    element: <PublicLayout><AboutPage /></PublicLayout>,
  },
  {
    path: '/services',
    element: <PublicLayout><ServicesPage /></PublicLayout>,
  },
  {
    path: '/team',
    element: <PublicLayout><TeamPage /></PublicLayout>,
  },
  {
    path: '/team/member/:id',
    element: <PublicLayout><TeamMemberPage /></PublicLayout>,
  },
  {
    path: '/contact',
    element: <PublicLayout><ContactPage /></PublicLayout>,
  },
  {
    path: '/booking',
    element: <PublicLayout><BookingPage /></PublicLayout>,
  },
  {
    path: '/faq',
    element: <PublicLayout><FAQPage /></PublicLayout>,
  },
  {
    path: '/blog',
    element: <PublicLayout><BlogPage /></PublicLayout>,
  },
  {
    path: '/blog/:id',
    element: <PublicLayout><BlogDetailPage /></PublicLayout>,
  },
  {
    path: '/gallery',
    element: <PublicLayout><GalleryPage /></PublicLayout>,
  },
  {
    path: '/admin/login',
    element: <AdminLogin />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboard />,
  },
  {
    path: '/admin/analytics',
    element: <AdminAnalytics />,
  },
  {
    path: '/admin/content',
    element: <AdminContent />,
  },
  {
    path: '/admin/services',
    element: <AdminServices />,
  },
  {
    path: '/admin/testimonials',
    element: <AdminTestimonials />,
  },
  {
    path: '/admin/posts',
    element: <AdminPosts />,
  },
  {
    path: '/admin/posts/new',
    element: <AdminPostNew />,
  },
  {
    path: '/admin/posts/edit/:id',
    element: <AdminPostEdit />,
  },
  {
    path: '/admin/faqs',
    element: <AdminFAQs />,
  },
  {
    path: '/admin/bookings',
    element: <AdminBookings />,
  },
  {
    path: '/admin/messages',
    element: <AdminMessages />,
  },
  {
    path: '/admin/team',
    element: <AdminTeam />,
  },
  {
    path: '/admin/contact-settings',
    element: <AdminContactSettings />,
  },
  {
    path: '/admin/about-settings',
    element: <AdminAboutSettings />,
  },
  {
    path: '/admin/site-design',
    element: <AdminSiteDesign />,
  },
  {
    path: '/admin/users',
    element: <AdminUsers />,
  },
  {
    path: '/admin/navbar-footer-settings',
    element: <AdminNavbarFooterSettings />,
  },
  {
    path: '/admin/gallery',
    element: <AdminGallery />,
  },
  {
    path: '*',
    element: <PublicLayout><NotFound /></PublicLayout>,
  },
];

export default routes;
